function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_10012",
  "data-name": "Group 10012",
  transform: "translate(4.621)"
}, React.createElement("g", {
  id: "Group_10011",
  "data-name": "Group 10011"
}, React.createElement("path", {
  id: "Path_11440",
  "data-name": "Path 11440",
  d: "M4083.25,88.1a6.5,6.5,0,1,0,6.5,6.5A6.507,6.507,0,0,0,4083.25,88.1Z",
  transform: "translate(-4076.75 -88.104)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_10014",
  "data-name": "Group 10014",
  transform: "translate(0 15.397)"
}, React.createElement("g", {
  id: "Group_10013",
  "data-name": "Group 10013"
}, React.createElement("path", {
  id: "Path_11441",
  "data-name": "Path 11441",
  d: "M4006.944,390.988a9.881,9.881,0,0,0-7.083-2.988h-3.081a9.881,9.881,0,0,0-7.083,2.988,10.1,10.1,0,0,0-2.928,7.122.773.773,0,0,0,.77.774H4009.1a.774.774,0,0,0,.771-.774A10.1,10.1,0,0,0,4006.944,390.988Z",
  transform: "translate(-3986.769 -388)"
})));

var SvgClients = function SvgClients(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Group_17012",
    "data-name": "Group 17012",
    width: 23.104,
    height: 26.281,
    viewBox: "0 0 23.104 26.281",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClients, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Clients.34f7d1af.svg";
export { ForwardRef as ReactComponent };